import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { StoreEnrollmentJourneySerialNumber } from '../../../../actions/MyAccount';
import { routePath } from '../../../../constants/Routes';
import { pushDataLayer } from '../../../../constants/AppMethod';
import { SOURCE_MY_DEVICE } from '../../../../pages/MyDevices/components/SuppliesComponent';

/**
 * Returns a stable `navigateOnSuccess(options)` callback that:
 *  1. Fires a dataLayer event
 *  2. Stores the enrollment serial number
 *  3. Shows the success overlay for 3 s, then routes away
 *
 * @param {object} params
 * @param {string}   params.source                  – forwarded from WebConnection props
 * @param {Function} params.setShowSuccessContent    – local state setter
 * @param {Function} params.AddDeviceSetCurrentStepIndex – forwarded from WebConnection props
 */
const useNavigateOnEnrollmentSuccess = ({ source, setShowSuccessContent, AddDeviceSetCurrentStepIndex, navTimerRef }) => {
    const dispatch = useDispatch();
    const history  = useHistory();

    /**
     * @param {object} [options]
     * @param {string}  [options.dataLayerEvent='brother-plus']  – first arg passed to pushDataLayer
     * @param {string}  [options.serialNumber]                   – passed to StoreEnrollmentJourneySerialNumber
     */
    const navigateOnEnrollmentSuccess = useCallback((options = {}) => {
        const { dataLayerEvent = 'brother-plus', serialNumber } = options;

        pushDataLayer(dataLayerEvent, 'status', 'success');
        dispatch(StoreEnrollmentJourneySerialNumber(serialNumber));
        setShowSuccessContent(true);

        if (navTimerRef.current) clearTimeout(navTimerRef.current);

        navTimerRef.current = setTimeout(() => {
            navTimerRef.current = null;
            setShowSuccessContent(false);
            (source === SOURCE_MY_DEVICE)
                ? AddDeviceSetCurrentStepIndex(2)
                : history.push(routePath.DASHBOARD);
        }, 3000);
        // No return — timer is owned by navTimerRef, not by effect cleanup
    }, [dispatch, history, source, setShowSuccessContent, AddDeviceSetCurrentStepIndex, navTimerRef]);

    return navigateOnEnrollmentSuccess;
};

export default useNavigateOnEnrollmentSuccess;